<template>
  <div :class="{
    'customer-pass': true,
    'customer-pass-odd': itemStyle === 'odd'
  }">
    <div class="data-col-1">
      {{ passData.pass.name }}<br>
      <small v-if="passData.pass.type === 'USAGE'">{{ $t('passes.types.usage') }}</small>
      <small v-if="passData.pass.type === 'DURATION'">{{ $t('passes.types.duration') }}</small>
      <small v-if="passData.pass.type === 'DAYS'">{{ $t('passes.types.days') }}</small>
      <small v-if="passData.pass.type === 'MONTHS'">{{ $t('passes.types.months') }}</small><br>
      <template v-if="passData.payment">
        <small>
          {{ $t('paymentsListItem.date') }}: {{ passData.payment.created_at.split('T').map(item => item.split('.')[0]).join(' ') }}
        </small>
        <br>
      </template>
      <small v-if="paymentsEnabled">
        <label>{{ $t('passesActive.payment') }}:</label>
        <span
          v-if="passData.is_paid"
          class="text-success">
          {{ $t('passesActive.paymentStatus.isPaid') }}
        </span>
        <span
          v-else
          class="text-danger">
          {{ $t('passesActive.paymentStatus.isNotPaid') }}
        </span>
      </small>
      <br>
      <small>{{ $t('passesActive.code') }}:</small>
      <small>{{ passData.code }}</small>
      <br>
      <small
        v-if="isInactive"
        class="pass-is-inactive">
        {{ $t('passesActive.thisPassIsInactive') }}
      </small>
      <small
        v-if="isWaiting"
        class="pass-is-waiting">
        {{ $t('passesActive.thisPassIsWaiting') }}
      </small>
    </div>

    <div class="data-col-2">
      <small><strong>{{ $t('day.from') }}</strong> {{ passData.valid_from }}</small><br>
      <small><strong>{{ $t('day.to') }}</strong> {{ passData.valid_to }}</small><br>
      <small>
        <strong>{{ $t('passesActive.left') }}:</strong>
        <span :class="passData.amount_left_to_use === 0 ? 'is-danger' : 'is-success'">
          {{ passData.amount_left_to_use }}
          <template v-if="passData.pass.type === 'DAYS' || passData.pass.type === 'MONTHS'">
            {{ $tc('passes.days', passData.amount_left_to_use) }}
          </template>
          {{ $t('common.ui.from') }}
          {{ passData.amount_total_to_use }}
          <template v-if="passData.pass.type === 'DAYS' || passData.pass.type === 'MONTHS'">
            {{ $tc('passes.days', passData.amount_total_to_use) }}
          </template>
        </span>

        <template v-if="passData.pass.type === 'USAGE' || passData.pass.type === 'DURATION'">
          <br>
          <strong>
            {{ $t('passesActive.toPostpone') }}:
          </strong>
          <span :class="passData.amount_left_to_postpone === 0 ? 'is-danger' : 'is-success'">
            {{ passData.amount_left_to_postpone }} {{ $t('common.ui.from') }} {{ passData.amount_total_to_postpone }}
          </span>
        </template>

        <div class="services-wrapper">
          <strong>
            {{ $t('passes.services') }}:
          </strong>

          <a
            v-if="passData.pass && passData.pass.services && passData.pass.services.length"
            href="#"
            @click.stop.prevent="showInfo('customer-pass-' + passData.id)">
            {{ passData.pass.services.length }}
          </a>

          <span v-else>
            {{ $t('reservationParametersListItem.allServices') }}
          </span>

          <info-box
            :ref="'customer-pass-' + passData.id"
            :spacing="32"
            position="bottom"
            size="bigger">
            <div slot="content">
              <div
                v-for="(service, index) of passData.pass.services"
                class="info-box-service"
                :key="'info-box-service-' + service.id + '-' + index">
                <span
                  class="color"
                  :style="'background-color:' + service.color"></span>
                {{ service.name }}
              </div>
            </div>
          </info-box>
        </div>
      </small>
    </div>
  </div>
</template>

<script>
import Configuration from './../mixins/Configuration';
import UserTypes from './../mixins/UserTypes';

export default {
  name: 'customer-pass',
  props: [
    'passData',
    'itemStyle'
  ],
  mixins: [
    Configuration,
    UserTypes
  ],
  computed: {
    isInactive () {
      return !this.passData.published;
    },
    isWaiting () {
      let today = new Date();
      let startDate = new Date(this.passData.valid_from);

      return today.getTime() < startDate.getTime();
    }
  },
  methods: {
    showInfo (id) {
      this.$bus.$emit('body-clicked');

      setTimeout(() => {
        this.$refs[id].show();
      }, 0);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.customer-pass {
  align-items: center;
  border-radius: $border-radius-small;
  display: flex;
  padding: 1rem 5rem 1rem 1.5rem;
  position: relative;

  &-odd {
    background: rgba(255, 255, 255, .05);
  }

  .data-col-1 {
    width: 70%;
  }

  .data-col-2 {
    width: 30%;
  }

  .services-wrapper {
    display: block;
    margin-top: .1rem;
    position: relative;
    width: auto;

    a {
      cursor: help;
    }

    .info-box-service {
      align-items: center;
      display: flex;
      margin-right: 1rem;
      margin-bottom: .5rem;

      .color {
        border-radius: $border-radius-full;
        display: block;
        height: 1rem;
        margin-right: 1rem;
        width: 1rem;
      }
    }
  }
}

@media (max-width: 780px) {
  .customer-pass {
    .data-col-1 {
      width: 50%;
    }

    .data-col-2 {
      width: 50%;
    }
  }
}

@media (max-width: 580px) {
  .customer-pass {
    flex-direction: column;

    .data-col-1 {
      width: 100%;
    }

    .data-col-2 {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/CustomerPass.vue